module.exports = __webpack_public_path__ + "img/whats.7487ccaa.svg";